import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography } from '@components/Typography';

const ExpandedSection = ({ className, isOpen, onClick, text, children }) => {
    const iconStyles = { width: '17px', marginLeft: '6px', color: 'rgba(0, 0, 0, 0.6)' };
    return (
        <div className={className}>
            <div
                onClick={onClick}
                style={{
                    display: 'flex',
                    width: 'max-content',
                    alignItems: 'center',
                    marginBottom: isOpen ? '16px' : 0,
                    cursor: 'pointer',
                }}
            >
                <Typography variant="subtitle1" color="textPrimary">
                    {text}
                </Typography>
                {isOpen ? <ExpandLessIcon sx={iconStyles} /> : <ExpandMoreIcon sx={iconStyles} />}
            </div>
            {isOpen && children}
        </div>
    );
};

export default ExpandedSection;
